
<template>
  <div class="footers">
      <div>
        <P class="footer_tel">服务热线：4009883333</P>
        <P class="footer_info">Copyright ©2016 深圳市恒大饮品有限公司,All Rights Reserved</P>
      </div>
  </div>
</template>
<script>
export default {
  name: 'footers',
  props: {
    msg: String
  }
}
</script>
<style lang="scss" scoped>
    .footers{
        bottom: 0px;
        background: #222222;
        text-align: center;
        height: 110px;
        position: relative;
        min-width: 1200px;
        width: 100%;
        div{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            .footer_tel{
                font-size: 14px;
                color: #FFFFFF;
                letter-spacing: -0.49px;
                text-align: center;
                }
            .footer_info{
                margin-top: 10px;
                font-size: 12px;
                color: #9A9A9A;
                letter-spacing: 0;
                text-align: center;
            }
        }
    }
</style>
